'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClassDetailModal = exports.ClassDetailModalUnwrapped = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _Modal = require('decorators/Modal/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _ReadMore = require('./ReadMore');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MAX_DESCRIPTION_LENGTH = 175;

var ClassDetailModalUnwrapped = exports.ClassDetailModalUnwrapped = function ClassDetailModalUnwrapped(props) {
  var startTime = props.starttime,
      endTime = props.endtime,
      instructorName = props.teacher.name,
      klass = props.class,
      venue = props.venue,
      onModalClose = props.onModalClose;
  var klassName = klass.name,
      classDescription = klass.description;
  var venueName = venue.name,
      howToPrepare = venue.what_to_bring,
      image = venue.images.default;


  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement('div', { className: 'modal__header__img', style: { backgroundImage: 'url(' + image + ')' } }),
    _react2.default.createElement(
      'div',
      { className: 'modal__body' },
      _react2.default.createElement(
        'div',
        { className: 'ph- md-ph' },
        _react2.default.createElement(
          'span',
          { className: 'text--left' },
          _react2.default.createElement(
            'h3',
            { className: 'text--bold' },
            klassName
          ),
          _react2.default.createElement(
            'p',
            { className: 'mb0' },
            venueName
          ),
          _react2.default.createElement(
            'p',
            { className: 'mb0' },
            _react2.default.createElement(_reactIntl.FormattedDate, {
              value: startTime * 1000,
              weekday: 'long',
              day: 'numeric',
              month: 'long'
            })
          ),
          _react2.default.createElement(
            'p',
            { className: 'mb0' },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'classDetail.modal.starttime',
              defaultMessage: '{day} - {time}',
              values: {
                day: _react2.default.createElement(_reactIntl.FormattedTime, {
                  value: startTime * 1000,
                  hour: 'numeric',
                  minute: 'numeric'
                }),
                time: _react2.default.createElement(_reactIntl.FormattedTime, {
                  value: endTime * 1000,
                  hour: 'numeric',
                  minute: 'numeric'
                })
              }
            })
          ),
          instructorName && _react2.default.createElement(
            'p',
            null,
            instructorName
          ),
          _react2.default.createElement('hr', { className: 'mt mb' }),
          classDescription && classDescription.length > 0 && _react2.default.createElement(
            'span',
            { className: 'mb block' },
            _react2.default.createElement(
              'h6',
              { className: 'mb--' },
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'classDetail.modal.about',
                defaultMessage: 'About this class'
              })
            ),
            _react2.default.createElement(_ReadMore.ReadMore, {
              content: classDescription,
              maximumSummaryLength: MAX_DESCRIPTION_LENGTH
            })
          ),
          howToPrepare && howToPrepare.length > 0 && _react2.default.createElement(
            'span',
            { className: 'block' },
            _react2.default.createElement(
              'h6',
              { className: 'mb--' },
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'classDetail.modal.prepare',
                defaultMessage: 'How to prepare'
              })
            ),
            _react2.default.createElement(_ReadMore.ReadMore, {
              content: howToPrepare,
              maximumSummaryLength: MAX_DESCRIPTION_LENGTH
            })
          )
        ),
        _react2.default.createElement(
          'button',
          { className: 'bt bt--primary bt--lg bt--width-md mt-', onClick: onModalClose },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'classDetail.modal.done',
            defaultMessage: 'DONE'
          })
        )
      )
    )
  );
};

ClassDetailModalUnwrapped.propTypes = {
  onModalClose: _propTypes2.default.func.isRequired,
  starttime: _propTypes2.default.number.isRequired,
  endtime: _propTypes2.default.number.isRequired,
  venue: _propTypes2.default.shape({
    tz: _propTypes2.default.string.isRequired,
    name: _propTypes2.default.string.isRequired,
    what_to_bring: _propTypes2.default.string,
    images: _propTypes2.default.shape({
      default: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired,
  class: _propTypes2.default.shape({
    name: _propTypes2.default.string.isRequired,
    descritpion: _propTypes2.default.string
  }).isRequired,
  teacher: _propTypes2.default.shape({
    name: _propTypes2.default.string
  })
};

var ClassDetailModal = exports.ClassDetailModal = (0, _Modal2.default)({ lightClose: true })(ClassDetailModalUnwrapped);